/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { isDisabled } from './fields'
import { SelectField as MaterialSelect, MenuItem } from 'material-ui'
import { blueGrey300, grey800, red500 } from 'material-ui/styles/colors'
import R from 'ramda'

import * as constants from './constants'

class SelectField extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }

  selectionRenderer (values, child) {
    if (values === null || R.isEmpty(values)) {
      return ''
    }

    if (R.is(Array, values)) {
      return this.selectionRendererArray(values, child)
    }

    return this.selectionRendererString(values, child)
  }

  selectionRendererString (value, child) {
    return child.props.primaryText || value
  }

  selectionRendererArray (values, childs) {
    let res = ''
    for (let i = 0; i < values.length; ++i) {
      if (i > 0) {
        res += ', '
      }
      res += this.selectionRendererString(values[i], childs[i])
    }

    return res
  }

  setFloatingLabelText (floatingLabelText, meta) {
    if (floatingLabelText && meta && meta.mandatory) {
      return [floatingLabelText, <span key={0} style={{color: red500, fontSize:20, verticalAlign:'sub'}}> *</span>]
    }

    return floatingLabelText
  }

  handleChange (event, index, value) {
    if (this.props.onChange) {
      if (this.props.sourceKey) {
        this.props.onChange({target: {name: this.props.name}}, index, value, this.props.sourceKey)
      } else {
        this.props.onChange({target: {name: this.props.name}}, index, value)
      }
    }
  }

  render () {
    const { floatingLabelText, children, meta, onChange, intl, divStyle, sourceKey, placeholderMandatory, ...rest } = this.props
    const componentProps = {
      disabled: isDisabled(meta),
      floatingLabelText: this.setFloatingLabelText(floatingLabelText, meta),
      ...rest
    }
    const disabled = componentProps.disabled

    return (
      <div
        style={
          divStyle
            ? divStyle
            : Object.assign(
                {
                  height: componentProps.multiLine
                    ? 'auto'
                    : 72
                },
                {
                  width: this.props.fullWidth
                    ? '100%'
                    : undefined
                }
              )
        }
      >
        <MaterialSelect
          floatingLabelFixed
          labelStyle={disabled ? {color: grey800} : null}
          fullWidth={true}
          autoWidth={this.props.autoWidth || false}
          selectionRenderer={this.selectionRenderer}
          onChange={this.handleChange}
          errorStyle={{fontSize:10}}
          placeholder={
            placeholderMandatory
              ? this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)
              : this.props.placeholder
          }
          {
          ...componentProps
          }
        >
          { meta && !meta.mandatory && !componentProps.multiple
            ? <MenuItem
              primaryText={this.props.intl.formatMessage(constants.messages.EMPTY_MESSAGE)}
              value={null}
              checked={this.props.checked}
              key="nullable"
              style={{color: blueGrey300, fontStyle: 'italic'}}
            />
            : null
          }
          {
            children
          }
        </MaterialSelect>
        {
          meta &&
          meta.mandatory &&
          !this.props.value &&
          !placeholderMandatory &&
          !this.props.errorText
            ? <p className={'error-message'} style={{margin: 0}}>
              {this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)}
            </p>
            : null
        }
      </div>
    )
  }
}

export default injectIntl(SelectField)



// WEBPACK FOOTER //
// ./src/generic/form/SelectField.js